export default "/images/framework/BonusBarEng.3bb357fd.svg?3bb357fd";